const DeliveryMethodDescription = (freeShipping: boolean): string => {
  return freeShipping ? 'Free express shipping' : 'Express shipping';
};

export default DeliveryMethodDescription;
